import { IconX } from '@tabler/icons-react';
import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import { toast } from 'sonner';
import { getApi, postApi } from '../../../api/call.api';
import { urlApi } from '../../../api/url.api';
import { ORG_LIST, PROFILE } from '../../../statics/localStorage';
import { loadingHide, loadingShow } from '../../../loadingUi/loading.controller';
import { getOrganizationList } from '../../../api/api.global';

const AddTeamMemberModal = ({ buttonComponent, callback }) => {
    const [show, setShow] = useState(false);
    const [orgData, setOrgData] = useState(null);
    const [arrayList, setArrayList] = useState([]);
    const [invitePlatformType, setInvitePlatformType] = useState(1);

    const handleClose = () => { setArrayList([]); setShow(false) };
    const handleShow = () => setShow(true);

    const orgList = ORG_LIST();
    const profileData = PROFILE();

    let currentOrg = orgList.find(org => org.organizationId == profileData?.defaultOrganizationId);

    async function getOrgData() {
        let resp = await getApi(urlApi.getOrgDetailsByOrgId + profileData?.defaultOrganizationId);
        if (resp.responseCode === 200) {
            handleShow();
            setOrgData(resp.data);
        } else {
            setOrgData(null);
        }
    }

    const submit = async () => {
        let email = document.getElementById('member-email')?.value.trim();
        let mobile = document.getElementById('member-phone')?.value.trim();

        if (email || mobile || arrayList?.length) {
            loadingShow();
            let postData = {}
            if (invitePlatformType == 1) {
                if (email && arrayList?.length == 0) {
                    postData.email = [email];
                }
                else if (arrayList?.length && arrayList?.length < 10) {
                    if (!arrayList?.includes(email) && email != "") {
                        arrayList?.push(email);
                    }
                    postData.email = arrayList;
                }
            };

            if (invitePlatformType == 2) { postData.phone = mobile };

            if (postData.email || postData.mobile) {
                let resp = await postApi(postData, urlApi.inviteMember);
                loadingHide();
                if (resp.responseCode === 200) {
                    toast.success(resp.message);
                    callback?.();
                    handleClose();
                } else {
                    toast.error(resp?.message);
                }
            }
        } else {
            toast.error('Please enter email.');
        }
    }

    const changeName = async () => {
        let name = document.getElementById('org-name').value.trim();
        if (!name) {
            toast.error('Please enter a organization name.');
            return;
        };
        if (name?.toLowerCase() !== 'default') {
            loadingShow();
            let postData = {
                name: name,
                organizationId: profileData?.defaultOrganizationId,
            }
            let resp = await postApi(postData, urlApi.updateOrgDetails);
            loadingHide();
            if (resp.responseCode === 200) {
                getOrgData();
                getOrganizationList();
                toast.success(resp.message);
            } else {
                toast.error(resp?.message);
            }
        } else {
            toast.error('Please enter a different organization name except "Default"');
        }
    }
    const handlePlatformTypeChange = (e) => {
        setInvitePlatformType(parseInt(e.target.value));
    }

    const handleKeyDown = (e) => {
        if (e.key === 'Enter' || e.keyCode === 13) {
            let email = e.target?.value.trim();
            checkAndAddEmail(email, e);
        }
    }

    const checkAndAddEmail = (email, event) => {
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        if (emailRegex.test(email)) {
            if (!arrayList.includes(email) && arrayList?.length < 10) {
                setArrayList([...arrayList, email]);
                if (event) {
                    event.target.value = "";
                }
            } else {
                toast.warning('Email already exists in the list.');
            }
        } else {
            toast.warning('Please enter a valid email.');
        }
    }

    const onContactRemove = (contact) => {
        setArrayList(arrayList.filter(item => item !== contact));
    }

    return (
        <>
            <div className="cursor-pointer" onClick={() => getOrgData()}>
                {buttonComponent}
            </div>
            <Modal show={show} onHide={handleClose} backdrop="static" size='lg'>
                <Modal.Body className='rounded-xl'>
                    <div className="flex justify-between items-center">
                        <p className="text-md font-semibold">Add new member to {currentOrg?.name || 'current'} Organization</p>
                        <IconX className='cursor-pointer' onClick={handleClose} />
                    </div>
                    <hr className='my-3' />
                    <div className='mb-3'>
                        <label htmlFor="platform" className='text-sm font-semibold mb-1'>Invitation Channel</label>
                        <select name="" id="platform" className='w-full px-3 py-2 rounded-md border-2 text-sm cursor-not-allowed' disabled onChange={handlePlatformTypeChange} defaultValue={invitePlatformType}>
                            <option value="" disabled>Invitation Channel</option>
                            <option value="1">Through Email</option>
                            <option value="2">Through Phone</option>
                        </select>
                    </div>

                    {
                        orgData?.organizationName?.toLowerCase() == "default" ? <>
                            <p className='mb-3 text-sm font-light text-center text-orange-600 italic'>You have to change the organization name before inviting anyone. <br /> after name successfully changed the invitation window will appear. </p>
                            <div className='w-full !mb-4'>
                                <p className="text-md font-semibold mb-1.5">Organization Name</p>
                                <input type="text" className="form-control w-full" placeholder="Org Name" id='org-name' defaultValue={orgData?.organizationName} maxLength={140} />
                            </div>
                        </> :
                            <>
                                <p className='mb-3 text-sm font-light text-center text-orange-600 italic'>
                                    {/* You can enter either their email or mobile , <br /> 
                                    after this the member will get an email or SMS or whatsapp message ,  <br /> */}
                                    member can go through the link provided and should accept or reject upon their preferences.</p>

                                {invitePlatformType == 2 && <div className='w-full !mb-4'>
                                    <p className="text-md font-semibold mb-1.5">Member's Mobile</p>
                                    <input type="tel" key={'member-phone'} className="form-control w-full" placeholder="98XXXXXXXX" id='member-phone' maxLength={10} />
                                </div>}

                                {invitePlatformType == 1 && <div className='w-full !mb-6'>
                                    <p className="text-md font-semibold mb-1.5">Member's Email</p>
                                    <p className='text-xs text-gray-500 mb-2'>*Press 'ENTER' after every email address can lead to multiple email invitation at once.</p>
                                    <input type="text" className="form-control w-full" placeholder="xxxx@ab.com" id='member-email' onKeyDown={(e) => handleKeyDown(e)} maxLength={255} />
                                </div>}

                                {arrayList?.length > 0 && <p>{invitePlatformType == 1 ? "Emails" : "Mobile Numbers"}</p>}
                                {
                                    arrayList.length > 0 && <div className='flex flex-wrap gap-3 !my-2'>
                                        {arrayList.map((data, index) => (
                                            <div key={index} className='border-2 border-gray-300 !px-2 !py-1 rounded-md text-sm flex gap-1.5 items-center'>
                                                <p> {data}</p>
                                                <button onClick={() => onContactRemove(data)}><IconX size={18} /></button>
                                            </div>
                                        ))}
                                    </div>
                                }


                                {invitePlatformType == 1 && <p className='text-xs text-gray-500'>*Maximum 10 emails can be sent at once.</p>}
                                {invitePlatformType == 2 && <p className='text-xs text-gray-500'>*Maximum 10 phone numbers can be sent at once.</p>}

                            </>
                    }
                    <hr className='my-3' />

                    <div className='flex justify-end gap-3'>
                        <button className='cancel-btn' onClick={handleClose}>Cancel</button>
                        {orgData?.organizationName?.toLowerCase() == "default" ? <button className='primary-btn' onClick={() => changeName()}>Change Name</button> : <button className='primary-btn' onClick={() => submit()}>Invite</button>}
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default AddTeamMemberModal